import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  0% { transform: scale(1); }\n  10% { transform: scale(1.1); }\n  20% { transform: scale(1.2); }\n  30% { transform: scale(1.3); }\n  40% { transform: scale(1.4); }\n  50% { transform: scale(1.5); }\n  60% { transform: scale(1.4); }\n  70% { transform: scale(1.3); }\n  80% { transform: scale(1.2); }\n  90% { transform: scale(1.1); }\n  100% { transform: scale(1); }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  // position: absolute;\n  top: 0;\n  left: 0;\n  animation: ",
        " 5s linear infinite;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled, { keyframes } from "styled-components";
import PanIcon from "./PanIcon";
var pulse = keyframes(_templateObject());
var Container = styled.div.withConfig({
    componentId: "sc-d12f307-0"
})(_templateObject1());
var FloatingPanIcon = styled(PanIcon).withConfig({
    componentId: "sc-d12f307-1"
})(_templateObject2(), pulse);
var Spinner = function(param) {
    var _size = param.size, size = _size === void 0 ? 128 : _size;
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsx(FloatingPanIcon, {
            width: "".concat(size, "px")
        })
    });
};
export default Spinner;
